import { Component } from 'solid-js'
import GenerateImageOptionButton from './GenerateImageOptionButton'

const GenerateImageBodyOptions: Component<{
  updatePrompt: (value: string, replacePrompt: boolean) => void
  currentPrompt: string
}> = (props) => {
  return (
    <div class="flex flex-row flex-wrap gap-3">
      <GenerateImageOptionButton
        title="Slim"
        value="slim body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('slim body')}
      />
      <GenerateImageOptionButton
        title="Muscular"
        value="muscular body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('muscular body')}
      />
      <GenerateImageOptionButton
        title="Chubby"
        value="chubby body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('chubby body')}
      />
      <GenerateImageOptionButton
        title="Skinny"
        value="skinny body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('skinny body')}
      />
      <GenerateImageOptionButton
        title="Tall"
        value="tall body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('tall body')}
      />
      <GenerateImageOptionButton
        title="Short"
        value="short body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('short body')}
      />
      <GenerateImageOptionButton
        title="Average"
        value="average body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('average body')}
      />
      <GenerateImageOptionButton
        title="Curvy"
        value="curvy body"
        onClick={props.updatePrompt}
        isSelected={props.currentPrompt.includes('curvy body')}
      />
    </div>
  )
}

export default GenerateImageBodyOptions
